import { render } from "./blackList.vue?vue&type=template&id=0fccfc08&scoped=true"
import script from "./blackList.vue?vue&type=script&lang=js"
export * from "./blackList.vue?vue&type=script&lang=js"

import "./blackList.vue?vue&type=style&index=0&id=0fccfc08&scoped=true&lang=css"
import "./blackList.vue?vue&type=style&index=1&id=0fccfc08&lang=css"
script.render = render
script.__scopeId = "data-v-0fccfc08"

export default script